import * as React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { Button } from '../ui';

export interface BackLinkProps {
  /** When true, renders an icon-only button with the label as the accessible name (no visible text) */
  iconOnly?: boolean;
  /** The translated label text (e.g. "Back") */
  label: string;
  /** Optional route params to pass to the Link */
  params?: Record<string, string>;
  /** The route path to navigate back to */
  to: string;
}

export function BackLink({ iconOnly = false, label, params, to }: BackLinkProps): React.JSX.Element {
  if (iconOnly) {
    return (
      <Button asChild className="h-8 w-8 shrink-0" size="icon" variant="ghost">
        <Link aria-label={label} params={params} to={to}>
          <ArrowLeft className="rtl:rotate-180 h-4 w-4" />
        </Link>
      </Button>
    );
  }

  return (
    <Button asChild className="h-10 w-fit gap-2 rounded-lg px-4 py-2" variant="ghost">
      <Link params={params} to={to}>
        <ArrowLeft className="rtl:rotate-180" size={16} />
        {label}
      </Link>
    </Button>
  );
}
